import axios from 'axios';

// Gestione → Salute del server e Sito ecommerce → Salute del server: query lente, errori e picchi.
// Il tempo reale arriva dal socket (stanza 'serverhealth'), non da qui.
const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}serverhealth/${path}`;

const actions = {
	fetchSummary: async (context, params) => (await axios.get(url(context, 'summary'), { ...auth(context), params })).data.data,
	fetchLogs: async (context, params) => (await axios.get(url(context, 'logs'), { ...auth(context), params })).data.data,
	fetchSpikes: async (context, params) => (await axios.get(url(context, 'spikes'), { ...auth(context), params })).data.data,
};

export default {
	namespaced: true,
	state: {},
	mutations: {},
	getters: {},
	actions,
};
